import React from 'react'

const NotFound = () => {
  return (
    <div className='w-50 mx-auto text-center'>
        <hr className='my-4 w-75 mx-auto' />
        <h3>No Posts found</h3>
        <hr className='my-4 w-75 mx-auto' />
    </div>
  )
}

export default NotFound